import { CURRENT_USER_API_ENDPOINT } from '@marketplace-web/shared/api-client'
import { UserResp } from 'types/api/response/user-resp'

import { api } from './api'

export const getCurrentUser = () => api.get<UserResp>(CURRENT_USER_API_ENDPOINT)
